import { theme } from '@bvi/mui-theme';

export const styles = {
  skeleton: {
    ml: '0.5em',
    display: 'inline-block',
  },
  count: { ml: '0.5em', color: theme.palette.grey['200'] },
};
